import { render, staticRenderFns } from "./otherPaymentRequest.vue?vue&type=template&id=e2411d80&scoped=true"
import script from "./otherPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./otherPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./otherPaymentRequest.vue?vue&type=style&index=0&id=e2411d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2411d80",
  null
  
)

export default component.exports